<template>
  <div v-if="!data">
    <h3>Липсват данни за този филтър</h3>
  </div>
  <v-row v-else align="start" justify="center" class="ma-0 px-2">
    <v-range-slider hide-details="" v-model="range" v-bind="$attrs" :max="max" :min="min" class="align-center" @change.self="setRange()">
      <template v-slot:prepend>
        <!-- <v-text-field :value="value[0]" class="mt-0 pt-0" hide-details single-line style="width: 70px" v-model.number="range[0]" @input="setRange()"></v-text-field> -->
        <v-text-field class="mt-0 pt-0" hide-details single-line style="width: 70px" v-model.number="range[0]" @input="setRange()"></v-text-field>
      </template>
      <template v-slot:append>
        <!-- <v-text-field :value="value[1]" class="mt-0 pt-0" hide-details single-line style="width: 70px" v-model.number="range[1]"  @input="setRange()"></v-text-field> -->
        <v-text-field class="mt-0 pt-0" hide-details single-line style="width: 70px" v-model.number="range[1]" @input="setRange()"></v-text-field>
      </template>
    </v-range-slider>
  </v-row>
</template>

<script>
export default {
  props: ["data", "value"],
  computed: {},
  data() {
    return {
      min: 0,
      max: 0,
      range: [0, 0],
    };
  },
  methods: {
    // isNumberRR(event, value) {
    //   var allowedChars = "0123456789.";
    //   var invalidKey = (event.key.length === 1 && allowedChars.indexOf(event.key) == -1) || (event.key === "." && value.indexOf(".") > -1);
    //   return invalidKey && event.preventDefault();
    // },
    setRange() {
      if (this.range[0] < this.min) {
        this.range[0] = this.min;
      }
      if (this.range[0] > this.max) {
        this.range[0] = this.max;
      }
      if (this.range[1] < this.min) {
        this.range[1] = this.min;
      }
      if (this.range[1] > this.max) {
        this.range[1] = this.max;
      }

      this.$emit("input", this.range);
      this.$emit("change", this.range);
    },
  },
  mounted() {
    if (this.data != undefined) {
      this.min = this.data[0];
      this.max = this.data[1];

      if (this.min && this.max && this.max == this.min) {
        this.min--;
      }
      if (this.value[0] == null) {
        this.range = [this.min, this.max];
      } else {
        this.range = [this.value[0], this.value[1]];
      }
    }
  },
  beforeMount() {
    // this.setRange();
  },
};
</script>
